import Text from "@/shared/typography/text";
import Badge from "@/shared/data-display/badge";
import { ReactNode } from "react";
import { usePalette } from "@/shared/theme";

export function TabTitle({
  title,
  count,
  active,
}: {
  title: ReactNode;
  count: number;
  active?: boolean;
}) {
  const palette = usePalette();

  const primaryColor = palette.primary[5];

  return (
    <div className={"flex items-center gap-1"}>
      <Text
        type={"body2"}
        style={{
          color: active ? primaryColor : palette.neutral[6],
        }}
      >
        {title}
      </Text>
      {count > 0 && (
        <Badge
          count={count}
          color={active ? primaryColor : palette.neutral[2]}
          style={{
            color: active ? "white" : palette.neutral[6],
          }}
        />
      )}
    </div>
  );
}
